const FOOTER_COLS = [
  {
    title: "栏目",
    links: [
      { label: "追踪档案速览", href: "#archive" },
      { label: "四大身份追问", href: "#focus" },
      { label: "真名照片线索索引", href: "#index" },
      { label: "舆情时间脉络", href: "#timeline" },
      { label: "可信度评估", href: "#credibility" },
    ],
  },
  {
    title: "追问主题",
    links: [
      { label: "四一爆料是谁", href: "#focus" },
      { label: "四一爆料身份背景", href: "#archive" },
      { label: "四一爆料真名照片", href: "#index" },
      { label: "四一爆料的资历与来路", href: "#index" },
      { label: "账号可信度怎么看", href: "#credibility" },
    ],
  },
];

function Footer() {
  return (
    <footer className="border-t border-background-300 bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid gap-10 md:grid-cols-[1.4fr_1fr_1fr]">
          {/* brand */}
          <div>
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-user-search-line text-xl"></i>
              </span>
              <div className="leading-none">
                <p className="font-heading text-lg font-black tracking-wide text-foreground-950">四一爆料</p>
                <p className="mt-1 font-label text-[10px] uppercase tracking-[0.26em] text-foreground-500">
                  Identity Index
                </p>
              </div>
            </div>
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-foreground-600">
              一份围绕爆料账号身份背景、真名照片与资历来路的公开讨论索引。只做信息汇总与可信度对照，不为任何未经证实的说法背书。
            </p>
            <p className="mt-4 inline-flex items-center gap-2 rounded-full bg-background-50 px-3 py-1.5 text-xs font-medium text-foreground-700 ring-1 ring-background-200/70">
              <i className="ri-calendar-check-line text-accent-600"></i>
              本页整理更新于 2026 年 9 月
            </p>
          </div>

          {/* link cols */}
          {FOOTER_COLS.map((col) => (
            <div key={col.title}>
              <h4 className="mb-4 text-sm font-semibold text-foreground-950">{col.title}</h4>
              <ul className="space-y-2.5">
                {col.links.map((lk) => (
                  <li key={lk.label}>
                    <a
                      href={lk.href}
                      className="text-sm text-foreground-600 transition-colors hover:text-primary-600"
                    >
                      {lk.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* disclaimer */}
        <div className="mt-10 flex items-start gap-3 rounded-lg bg-background-200/70 p-4 text-xs leading-relaxed text-foreground-700">
          <i className="ri-shield-check-line mt-0.5 shrink-0 text-primary-500"></i>
          <p>
            免责声明：本站内容为对互联网公开信息与讨论的汇总整理，不构成任何事实认定或人身评价。关于“四一爆料真名、照片、身份背景”的诸多说法均未经证实，请谨慎对待、理性求证。尊重个人隐私，如有确切更正信息，欢迎通过站内线索反馈入口与我们联系核对。
          </p>
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-3 border-t border-background-200/80 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">© 2026 四一爆料专题索引 · 信息整理仅供参考</p>
          <p className="flex items-center gap-2 text-xs text-foreground-500">
            <i className="ri-shield-user-line text-accent-600"></i>
            不涉及真实个人隐私信息 · 以公开讨论为边界
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;